module.exports = "/images/example_case_3.png?d0b421312e9f262ef68b1461438ef29c";